export default __webpack_public_path__ + "static/media/orders.91481683.svg";